



























import { Component, Vue } from 'vue-property-decorator';
import { VueCropper } from 'vue-cropper';
import { uploadAvatar } from '@/apis/myInfo/myInfo';
import i18n from '@/lang';

@Component({
  components: {
    VueCropper
  }
})
export default class Avatar extends Vue {
  private defaultOptions = {
    img: '', //裁切图片的地址
    outputSize: 0.6, //裁剪生成图片的质量 0.1-1
    full: false, //是否输出原图比例的截图
    outputType: 'png', //裁剪生成图片的格式
    canMove: true, //图片是否允许滚轮缩放
    fixedBox: false, //固定截图框大小 不允许改变
    original: true, //上传图片按照原始比例渲染
    canMoveBox: true, //截图框能否拖动
    autoCropWidth: 200, // 截图框的宽度
    autoCropHeight: 200, // 截图框的高度
    autoCrop: true, //是否默认生成截图框
    centerBox: true, // 截图框是否被限制在图片里面
    // 开启宽度和高度比例
    fixed: true,
    fixedNumber: [1, 1]
  };

  // 遮罩层
  private show: boolean = false;

  created() {
    this.defaultOptions.img = sessionStorage.headImg || '';
  }

  finish() {
    this.show = true;
    const cropBlob: any = this.$refs.cropper;

    cropBlob.getCropData((data: string) => {
      this.getCropperImgSrc(data);
    });
  }

// 获取裁切好的图片地址
  getCropperImgSrc(data: string) {
    let imgFile = this.dataURLtoFile(data);
    let formData = new FormData();
    formData.append('file', imgFile);

    uploadAvatar(formData)
      .then(() => {
        this.$toast(i18n.t('Common.修改成功'));
      })
      .catch(() => {
        this.$toast(i18n.t('ktpMy.修改失败'));
      })
      .finally(() => {
        this.show = false;
        this.$store.dispatch('setUserInfo')
          .then(() => {
            this.$router.go(-1);
          });
      });
  }

  // 将base64图片转为文件形式
  dataURLtoFile(dataurl: any, filename = 'file') {
    let arr = dataurl.split(',');
    let mime = arr[0].match(/:(.*?);/)[1];
    let suffix = mime.split('/')[1];
    let bstr = atob(arr[1]);
    let n = bstr.length;
    let u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], `${filename}.${suffix}`, {
      type: mime
    });
  }


  beforeDestroy() {
    // 离开页面清除头像数据
    delete sessionStorage.headImg
  }

}
